import { useSelector } from "react-redux";

export const useTheme = () => {
  const { isDark } = useSelector(({ isDark }) => isDark);

  return {
    colors: {
      background: isDark ? "#18181B" : "#fff",
      text: isDark ? "#fff" : "#18181B",
      border: isDark ? "#423e3e" : "#f2f2f2",
      hover: isDark ? "#423e3e" : "#f8f8f8",
    },
    palette: {
      black: isDark ? "#fff" : "#18181B",
      white: isDark ? "#18181B" : "#fff",
      primary: {
        main: "#172a4f",
        dark: "#0f1f3d",
        light: "#1f3a6a",
        contrastText: "#fff",
      },
      text: {
        primary: isDark ? "#fff" : "#18181B",
        secondary: isDark ? "#ccc" : "#666",
      },
      background: {
        default: isDark ? "#18181B" : "#fff",
        paper: isDark ? "#423e3e" : "#fff",
      },
      divider: isDark ? "#423e3e" : "#f2f2f2",
      teal: "#00feb9",
      grey: {
        0: isDark ? "#666" : "#ccc",
      },
      gradients: {
        blueGradient: "linear-gradient(to bottom, #172a4f, #284a78, #3b6aa1)",
      },
    },
    shadows: {
      light: "0px 4px 6px rgba(0, 0, 0, 0.1)",
      dark: "0px 4px 6px rgba(255, 255, 255, 0.15)",
    },
    // New design colors and fonts
    breakpoints: {
      mobile: "480px",
      tablet: "768px",
      desktop: "1024px",
    },
    typography: {
      fontFamily: "Gilroy, sans-serif",
      hero: {
        mobile: { fontSize: "40px", letterSpacing: "0%", lineHeight: "auto" },
        desktop: { fontSize: "64px", letterSpacing: "0%", lineHeight: "auto" },
      },
      h1: {
        mobile: { fontSize: "24px", letterSpacing: "0%", lineHeight: "auto" },
        desktop: { fontSize: "32px", letterSpacing: "0%", lineHeight: "auto" },
      },
      h2: {
        mobile: { fontSize: "20px", letterSpacing: "0%", lineHeight: "auto" },
        desktop: { fontSize: "24px", letterSpacing: "0%", lineHeight: "auto" },
      },
      h3: {
        mobile: { fontSize: "18px", letterSpacing: "0%", lineHeight: "auto" },
        desktop: { fontSize: "20px", letterSpacing: "0%", lineHeight: "auto" },
      },
      body1: {
        mobile: { fontSize: "15px", letterSpacing: "0%", lineHeight: "auto" },
        desktop: { fontSize: "18px", letterSpacing: "0%", lineHeight: "auto" },
      },
      body2: {
        mobile: { fontSize: "13px", letterSpacing: "0%", lineHeight: "auto" },
        desktop: { fontSize: "16px", letterSpacing: "0%", lineHeight: "auto" },
      },
      caption: {
        mobile: { fontSize: "12px", letterSpacing: "0%", lineHeight: "auto" },
        desktop: { fontSize: "14px", letterSpacing: "0%", lineHeight: "auto" },
      },
      label: {
        mobile: { fontSize: "11px", letterSpacing: "0%", lineHeight: "auto" },
        desktop: { fontSize: "13px", letterSpacing: "0%", lineHeight: "auto" },
      },
    },
    primary: isDark ? "#5389FF" : "#5389FF",
    primary90: isDark ? "#1E2332" : "#EEF3FF",
    primary95: isDark ? "#1B1E26" : "#F6F9FF",
    alert: isDark ? "#FF307C" : "#FF307C",
    negative: isDark ? "#E00047" : "#E00047",
    negative90: isDark ? "#2C161F" : "#FCE5ED",
    middle: isDark ? "#F7931A" : "#F7931A",
    middle90: isDark ? "#2E241B" : "#FEF4E8",
    positive: isDark ? "#03B6A7" : "#03B6A7",
    positive90: isDark ? "#162829" : "#E6F8F6",
    dark: isDark ? "#FFFFFF" : "#18181B",
    midGrey: isDark ? "#B5B6C0" : "#656776",
    grey: isDark ? "#3B3C45" : "#DEDFE3",
    lightGrey: isDark ? "#242429" : "#F1F1F3",
    light: isDark ? "#18181B" : "#FFFFFF",
    alwaysLight: isDark ? "#FFFFFF" : "#FFFFFF",
    background: isDark ? "#18181B" : "#FFFFFF",
    light95: isDark ? "#18181BF2" : "#FFFFFFF2",
    light90: isDark ? "#18181BE6" : "#FFFFFFE6",
    light80: isDark ? "#18181BCC" : "#FFFFFFCC",
    light20: isDark ? "#18181B33" : "#FFFFFF33",
    modalBackground: isDark ? "#FFFFFF1A" : "#18181BCC",
  };
};
